module.exports = __webpack_public_path__ + "img/glued-glossy-hard-cover.e803c598.png";